import { defineMessages } from 'react-intl';

export default defineMessages({
    exitToDashBoardEHpolicyChange: {
        id: 'endorsement.eh.full.views.eh-confirmation.EXIT TO DASHBOARD',
        defaultMessage: 'EXIT'
    }
});
